import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import { Phone, Search, } from "@mui/icons-material";
import { IconButton, Checkbox, Box} from '@mui/material';
import NoTelpSearchPopUp from '../NoTelpSearchPopUp';
import Dialog from '@mui/material/Dialog';
import PhoneInput, { getCountries, getCountryCallingCode, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import { formatPhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function NewKlienPopUp({handleClose, nextButton, setklienID, setcompanyID, companyID}){
    const [error,setError] = useState("")
    const [namaKlien,setNamaKlien] = useState("")
    const [noTelp,setNoTelp] = useState(["..."])
    const [companies,setCompanies] = useState([
        {NamaPT:"...", EmailPT:'', IndustriPT:'', posisi:["Direktur"]}
    ])
    
    const [ktp,setKTP] = useState("")
    const [npwp,setNPWP] = useState("")
    const [email,setEmail] = useState([""])
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredCompany, setIsHoveredCompany] = useState(false);

    const handleNamaKlien = (event) => {
        setNamaKlien(event.target.value);
    }
    const handleNoTelp = (event) => {
        const values =[...noTelp];
        values[0] = event.target.value;
        setNoTelp(values);
        console.log(noTelp);
    }
    const handleCompany = (post) => {
        console.log(post.namaPerusahaan)
        const values =[...companies];
        values[0].NamaPT = post.namaPerusahaan;
        console.log(post.id)
        values[0].CompanyID= post._id;
        setCompanies(values);
    }

    const handleKTP = (event) => {
        let value = event.target.value;
        setKTP(value);
      };
    const handleNPWP = (event) => {
        let value = event.target.value;
  value = value.replace(/\D/g, ""); // Remove any non digit character
  value = value.replace(/^(\d{2})(\d)/, "$1.$2");
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})-(\d{1})(\d)/, "$1.$2.$3-$4.$5");
  value = value.slice(0,20); // Limit length to 15 digits and 5 special characters (20 in total)
        setNPWP(value);
      };

      const handleAlamat = (event) => {
        setAlamat(event.target.value)
      }
      
    const handleEmail = (event) => {
        const values =[...email];
        values[0] = event.target.value;
        setEmail(values);
        console.log(email);
    }

    const [companyIDtoSave,setcompanyIDtoSave] = useState("")
    const [phoneNumber, setPhoneNumber] = useState('');
  const [country, setCountry] = useState('ID'); // Indonesia's code is ID

  const handleCountryChange = (countryCode) => {
    setCountry(countryCode);
  };
    
    function saveKlien(e){
      console.log(companies)
    if (!isValidPhoneNumber(phoneNumber)) {
      setError('Nomor Telepon Tidak Valid');
    } else {
      setError(null);
    
        const dataToSend = {
            Nama: namaKlien,
            Phone: noTelp,
            Companies: companies,
            KTP: ktp,
            NPWP: npwp,
            Alamat: alamat,
            Email: email,
            __v: 0, // Update this as needed
        };

        if(namaKlien === "" || noTelp === "" || alamat==="" ){
            console.log("gagal ada data kurang (Nama/No Telp/Alamat)")
        }else{
          if(fileKTP !== null || fileNPWP !== null){
          if (ktp !== "" || npwp !== "") {
            const currentDate = new Date();
            const birthDate = new Date(bDate);
            const age = Math.floor((currentDate - birthDate) / (365.25 * 24 * 60 * 60 * 1000));

            if (age >= 17) {
            console.log("sending data to backend")
            console.log("cek jika company ID ini sama:" + companyIDtoSave)
            // Assuming that fileKTP and fileNPWP are your file objects
            // Assuming that fileKTP and fileNPWP are your file objects
            const filesToUpload = [
              { file: fileKTP, name: 'fileKTP' },
              { file: fileNPWP, name: 'fileNPWP' }
            ];

            // Map over the files array and return an array of promises
            const uploadPromises = filesToUpload.map((fileObj) => {
              if (fileObj.file) { // if the file is not null, upload it
                return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`, {
                  params: {
                    filename: fileObj.name // send the filename to the server
                  }
                })
                .then(response => {
                  const uploadUrl = response.data.url;
                  const key = response.data.key; // Get the key from the response

                  return fetch(uploadUrl, {
                    method: 'PUT',
                    headers: {
                      'Content-Type': fileObj.file.type
                    },
                    body: fileObj.file
                  }).then(() => key); // After the file is uploaded, return the key
                })
                .catch(error => {
                  console.error('Error during file upload:', error);
                });
              }

              // if the file is null, return a resolved promise with value null
              return Promise.resolve(null);
            });

            // Wait for all upload operations to finish
            Promise.all(uploadPromises)
            .then(fileKeys => {
              const [ktpKey, npwpKey] = fileKeys; // Extract keys from the resolved values array

              // Now, post the data to your endpoint
              axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveKlienQuick`,{
                namaKlien,
                companies,
                email,
                ktp,
                ktpKey,
                npwp,
                npwpKey,
                companyIDtoSave,
                phoneNumber,
                alamat,
                bDate
              })
              .then((response) => {
                const newKlienData = response.data;
                nextButton(newKlienData);
                setklienID(response.data._id)
              })
              .catch((error) => {
                console.log(error.message);
                setError(error.response.data.message);
              });
            })
            .catch(error => {
              console.error("Error during file upload:", error);
            });


            }else{setError("Umur terlalu muda")}}else{            setError("Kurang KTP/NPWP")
          }}else{setError("Upload KTP/NPWP")}
        }
    }}

    const handleMouseEnter = () => {
        setIsHovered(true);
      };
    
      const handleMouseLeave = () => {
        setIsHovered(false);
      };
    

      const handleMouseEnterCompany = () => {
        setIsHoveredCompany(true);
      };
    
      const handleMouseLeaveCompany = () => {
        setIsHoveredCompany(false);
      };
    
      const handleIconClickCompany = () => {
        // handle search logic here
        console.log("Search clicked");
      };
      const [isDisabled, setIsDisabled] = useState(false);
      const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    borderRadius: "4px",
    position: "relative",
    textDecoration: "none",
    pointerEvents: "auto",
  },
  text: {
    color: "rgba(0, 0, 0, 1)",
    visibility: "visible",
  },
  iconButton: {
    color: "#fff",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    visibility: "hidden",
    zIndex: 1,
  },
  disabled: {
    textDecoration: "line-through",
    pointerEvents: "none",
  },
  disabledContainer: {
    backgroundColor: "#e0e0e0",
    border: "1px solid #bbb",
    cursor: "default",
  },
};
      const [openNoTelp, setOpenNoTelp] = useState(false);
      const [bDate, setBDate] = useState();
      const handleBDateChange = (date) => {
        setBDate(date);
    }
    const [alamat, setAlamat] = useState();
      const newNoTelp = () => {
        console.log("here")
        setOpenNoTelp(true);
    };
  
    const handleCloseNoTelp = () =>{
        setOpenNoTelp(false);
    }
    const fileInput = useRef(null);
    const fileInputKTP = useRef(null);

    const toggleCheckbox = () =>{
        if(isDisabled === false){
            const values =[...companies];
            values[0].NamaPT = "...";
            values[0].CompanyID = "";
            setCompanies(values);
            setIsDisabled(true)
        }else{
            setIsDisabled(false)
        }
    }
    const [uploadedNPWPStat, setUploadedNPWPStat] = useState(false);
    const [fileNPWP, setNPWPFile] = useState(null);
    const [npwpfileName, setNPWPFileName] = useState("");
  const handleNPWPFileChange = (event) => {
    setNPWPFile(event.target.files[0]);
    setNPWPFileName(event.target.files[0].name);
    setUploadedNPWPStat(true);
  };

  const clearnpwpFile = (event)=>{
    setNPWPFile(null);
    setNPWPFileName("");
    setUploadedNPWPStat(false);
  }

  const handleNPWPUploadButtonClick = () => {
    fileInput.current.click();
  };

  const [uploadedKTPStat, setUploadedKTPStat] = useState(false);
  const [fileKTP, setKTPFile] = useState(null);
  const [ktpfileName, setKTPFileName] = useState("");
const handleKTPFileChange = (event) => {
  setKTPFile(event.target.files[0]);
  setKTPFileName(event.target.files[0].name);
  setUploadedKTPStat(true);
};

const clearktpFile = (event)=>{
  setKTPFile(null);
  setKTPFileName("");
  setUploadedKTPStat(false);
}

const handleKTPUploadButtonClick = () => {
  fileInputKTP.current.click();
};



    return <Grid sx={{p:5}}>
            <Grid container>
                <Grid sm={5}> 
                    <p>Direktur/PIC:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleNamaKlien(event)}></TextField>
                </Grid>
            </Grid>
            <Grid container sx={{mt:3}}>
      <PhoneInput
        international
        defaultCountry="ID"
        value={phoneNumber}
        placeholder="Nomor Telepon"
        onChange={setPhoneNumber}
      />
    </Grid>

            <Grid container sx={{mt:5}}>
                <Grid sm={2}>
                <Checkbox onClick={toggleCheckbox}></Checkbox>
                </Grid>
                <Grid sm={10}>
                <p>Tidak ada Company</p>
                </Grid>
            </Grid>
            <Grid container sx={{ mt: 2 }} style={{ ...styles.container, ...(isDisabled ? styles.disabled : {}) }} >
                <Grid sm={5}>
                    <p>Company:</p>
                </Grid>
                <Grid sm={7}>
                    <div 
                    contentEditable={false}
                    style={{
                        ...styles.container,
                        border: `1px solid ${isHovered ? "#2196f3" : "#ccc"}`,
                        backgroundColor: isHovered ? "rgba(33, 150, 243, 1)" : "transparent",
                        cursor: isHovered ? "pointer" : "default",
                        ...(isDisabled ? styles.disabledContainer : {}),
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={isDisabled ? null : newNoTelp}
                    >
                    <span style={{ ...styles.text, color: isHoveredCompany ? "rgba(0, 0, 0, 0.2)" : "rgba(0, 0, 0, 1)" }}>
                        {companies[0].NamaPT}
                    </span>
                    <IconButton
                        style={{ ...styles.iconButton, visibility: isHovered ? "visible" : "hidden" }}
                    >
                        <Search />
                    </IconButton>
                    </div>
                </Grid>
                </Grid>
            <Dialog open={openNoTelp} onClose={handleCloseNoTelp}>
                <NoTelpSearchPopUp setCompanies={setCompanies} companies={companies} setcompanyIDtoSave={setcompanyIDtoSave} handleCompany={handleCompany} handleCloseNoTelp={handleCloseNoTelp} setcompanyID={setcompanyID}></NoTelpSearchPopUp>
            </Dialog>
            
            
            <Divider style={{ height: '1px', backgroundColor:"lightgrey"}} sx={{my:5}} />
            <Grid container sx={{mt:2,mb:2}}>

                <Grid sm={5}> 
                    <p>KTP/Passport:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField value={ktp} onChange={event => handleKTP(event)}></TextField>
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInputKTP}
                onChange={handleKTPFileChange}
                style={{ display: 'none' }}
              />
              <Button
                color={uploadedKTPStat ? "success" : "primary"}
                variant="contained"
                onClick={handleKTPUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Upload KTP/Passport
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {ktpfileName.length > 20 ? `${ktpfileName.slice(0, 17)}...` : ktpfileName}
              </Typography>
              {uploadedKTPStat && (
                <IconButton size="small" onClick={clearktpFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>

            <Grid container sx={{mt:2 ,mb:2}}>

                <Grid sm={5}> 
                    <p>NPWP:</p>
                </Grid>
                <Grid sm={7}>
                <TextField value={npwp} onChange={handleNPWP} />
                </Grid>
            </Grid>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInput}
                onChange={handleNPWPFileChange}
                style={{ display: 'none' }}
              />
              <Button
                color={uploadedNPWPStat ? "success" : "primary"}
                variant="contained"
                onClick={handleNPWPUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Upload NPWP
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {npwpfileName.length > 20 ? `${npwpfileName.slice(0, 17)}...` : npwpfileName}
              </Typography>
              {uploadedNPWPStat && (
                <IconButton size="small" onClick={clearnpwpFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>


            <Grid container sx={{mt:2}}>

                <Grid sm={5}> 
                    <p>Alamat:</p>
                </Grid>
                <Grid sm={7}>
                <TextField value={alamat} onChange={handleAlamat} />
                </Grid>
            </Grid>
            <Grid container sx={{mt:2}}>

                <Grid sm={5}> 
                    <p>Tanggal Lahir:</p>
                </Grid>
                <Grid sm={7}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={bDate}
                                    onChange={handleBDateChange}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>
                </Grid>
            </Grid>
            <Grid container sx={{mt:2, mb:4}}>

                <Grid sm={5}> 
                    <p>Email:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField type="email" value={email} onChange={event => handleEmail(event)} error={email && !email.includes('@')}
        helperText={email && !email.includes('@') ? 'Harus menggunakkan "@"' : null}></TextField>
                </Grid>
            </Grid>
            {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}

            <Button type="button" variant="contained" onClick={saveKlien}>Save & Use</Button>
            <RedButton type="button" variant="contained" onClick={handleClose}>Cancel</RedButton>

</Grid>    };